var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-container",style:(_vm.color ? 'color: ' + _vm.colorText + '!important; background-color: ' + _vm.color + '!important;' : '')},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }